export default {
    coupons: {
        create: {
            title: 'Create New Coupon',
            successMessage: 'New Coupon has been added'
        },
        list: {
            title: 'Active Coupons',
            createButton: 'add coupon',
            createButtonMobile: 'add',
            deleteSuccessMessage: 'Coupon deleted'
        },
        tableHeaders: [
            { text: 'ID', value: 'id', sortable: false },
            { text: 'Duration', value: 'duration', sortable: false },
            {
                text: 'Months',
                value: 'duration_in_months',
                sortable: false
            },
            { text: 'Discount off', value: '', sortable: false },
            {
                text: 'Max redemptions',
                value: 'max_redemptions',
                sortable: false
            },
            {
                text: 'Redeemed',
                value: 'times_redeemed',
                sortable: false
            },
            { text: 'Redeem by', value: 'redeem_by', sortable: false },
            { text: 'Valid', value: 'valid', sortable: false },
            { text: 'Controls', value: '', sortable: false }
        ],
        mobile: {
            sort: {
                date: 'Date Create'
            },
            filter: {
                status: {
                    name: 'Filter by Status',
                    filter: [
                        {
                            text: 'All',
                            value: null
                        },
                        {
                            text: 'Active',
                            value: true
                        },
                        {
                            text: 'Inactive',
                            value: false
                        }
                    ]
                }
            }
        }
    }
};
